<template>
  <div class="solution">
    <div class="header">
      <div class="header-body">
        <div class="header-body-title">互联网+解决方案</div>
        <div class="header-body-line"></div>
        <div class="header-body-desc">绽放工场专注于互联网+领域的业务深入与定制开发。公司配备人专业服务团队，深入了解各行业互联网+应用开发需求，提供涵盖移动互联网化业务平台搭建、政企级移动互联网定制应用开发等综合性解决方案，全方位助力政府及企业从业务、产品的移动互联网规划建设与升级改造。</div>
      </div>
      <figure class="bg"></figure>
    </div>
    <div class="body">
      <div class="body-list">
        <div class="body-list-item" v-for="(item, index) in list" :key="index">
          <div class="item-poster" @click="intoDetail(item)">
            <img :src="item.poster" />
          </div>
          <div class="item-info">
            <div class="item-title">{{item.title}}</div>
            <div class="item-desc">{{item.desc}}</div>
            <div class="item-detail" @click="intoDetail(item)">
              <span>查看详情</span>
              <img src="../../static/images/program_jump_icon_small@2x.png" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { list } from './solution/data'
export default {
  data () {
    return {
      list: list
    }
  },
  methods: {
    intoDetail (item) {
      this.$router.push(`/solution/detail/${item.id}`)
    }
  }
}
</script>
<style scoped>
.solution {
  min-height: 100vh;
}
.bg {
  width: 1920px;
  height: 560px;
  background-image: url('https://zfgc-yj-gzh.oss-cn-shenzhen.aliyuncs.com/zfgcImg/home_program_background%402x.png');
  background-size: 1920px 560px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: -1;
}
.header {
  text-align: center;
  color: #ffffff;
  height: 560px;
  overflow: hidden;
  position: relative;
}
.header-body {
  max-width: 1200px;
  margin: 220px auto 0;
}
.header-body-title {
  font-size:40px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(250,250,250,1);
}
.header-body-line {
  width:40px;
  height:1px;
  background:rgba(255,255,255,1);
  margin: 22px auto 30px;
}
.header-body-desc {
  font-size:18px;
  color:rgba(255,255,255,1);
}
.body {
  background-color: #FAFAFA;
  padding: 90px 20px;
}
.body-list {
  width: 1200px;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  margin: auto;
}
.body-list-item {
  width:386px;
  height:528px;
  background:rgba(255,255,255,1);
  margin-bottom: 20px;
  position: relative;
}
.item-poster {
  width: 100%;
  height: 240px;
  display: block;
  overflow: hidden;
  cursor: pointer;
}
.item-poster img {
  width: 100%;
  transition: transform .2s linear;
}
.item-poster img:hover {
  transform: scale(1.2);
}
.item-info {
  overflow: hidden;
  height: 288px;
  transition: box-shadow .1s linear;
}
.item-info:hover {
  box-shadow:0px 4px 32px 0px rgba(96,96,96,0.24);
}
.item-title {
  font-size:20px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(51,51,51,1);
  margin: 24px;
}
.item-desc {
  font-size:14px;
  font-family:Microsoft YaHei;
  font-weight:400;
  color:rgba(153,153,153,1);
  margin: 0 24px;
}
.item-detail {
  width: 102px;
  font-size: 18px;
  color: #FF574E;
  padding: 6px;
  vertical-align: middle;
  cursor: pointer;
  position: absolute;
  bottom: 24px;
  right: 24px;
  transition: transform .1s linear;
}
.item-detail img {
  width: 1.3em;
  margin-left: 10px;
  vertical-align: middle;
}
.item-detail:hover {
  transform: scale(1.3, 1.3);
}

</style>




// WEBPACK FOOTER //
// src/components/solution.vue